import * as React from 'react';
import {
  container,
  title,
} from './navbar.module.css';
import { Link } from 'gatsby';

const Navbar = () => {
  return (
    <div className={container}>
      <div className={title}>
        <h1><Link to='/'>Poetry in Ocean</Link></h1>
      </div>
    </div>
  );
}

export default Navbar;
